export function isSelectionType(selection, type) {
  if (!selection) {
    return false;
  }
  var serialized = selection.toJSON();
  return serialized.type === type;
}